import { useCallback } from 'react'
import { ModalOpenedSetTy } from '../../../../../../../../baseComponents/Modal/types'
import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import twinFetchPost from '../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { changeErrorMessage } from '../../../../../../../../utils/reducers/reduxDispatch'

interface ModalDeleteVariantValueProps extends ModalEditComponentProps { }

const ModalDeleteVariantValue: React.FC<ModalDeleteVariantValueProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleSubmit } = useModalDeleteVariantValueLogic({ setOpened, onSubmit })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={() => handleSubmit(allRowData || {})} translations={{
            title: t('sureDeleteVariantValueSub', '¿Seguro quieres eliminar esta variante?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

interface ModalDeleteVariantValueLogicProps {
    setOpened: ModalOpenedSetTy
    onSubmit: OnSubmit
}

const useModalDeleteVariantValueLogic = ({ setOpened, onSubmit }: ModalDeleteVariantValueLogicProps) => {
    const { t } = useTwinTranslation()

    const variantValueError = t('cannotDeleteVariantValue', 'No se puede eliminar el valor de la variante. Esta asignada a un producto.')

    const handleSubmit = useCallback(async (vals: TwinDictionary) => {
        const response = await twinFetchPost('/api/app/product/productVariant/variantValue/deleteVariantValue', vals)
        if (response.status === 200) {
            onSubmit?.(response, vals || {})
            setOpened(null)
        } else {
            const responseJSON = await response.json()
            if (responseJSON.errors[0].msg === 'Cannot delete variant value') {
                changeErrorMessage(variantValueError)
            }
        }
    }, [variantValueError, setOpened, onSubmit])

    return { handleSubmit }
}

export default ModalDeleteVariantValue